var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleIconRokkApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3648 14.8849C20.3313 11.3488 23.4163 9.62847 23.5573 9.54838C21.8102 7.13139 19.1022 6.80115 18.1505 6.77482C15.8761 6.54771 13.6699 8.06615 12.5113 8.06615C11.3296 8.06615 9.54546 6.79676 7.62255 6.83406C5.1481 6.87027 2.83321 8.22962 1.56361 10.3405C-1.05653 14.6446 0.89759 20.9696 3.40789 24.4486C4.66362 26.1535 6.13094 28.0549 8.05154 27.988C9.9305 27.9155 10.6324 26.8524 12.8998 26.8524C15.1465 26.8524 15.8056 27.988 17.7643 27.9452C19.7809 27.9155 21.0505 26.2336 22.2623 24.5144C23.7134 22.5626 24.2962 20.6382 24.3193 20.5395C24.2731 20.5241 20.4042 19.122 20.3648 14.8849ZM16.6647 4.48619C17.6753 3.28702 18.3668 1.65558 18.1748 0C16.7121 0.0614397 14.8829 0.959995 13.8295 2.13283C12.8975 3.16634 12.065 4.86032 12.2801 6.45336C13.9232 6.56965 15.6102 5.66671 16.6647 4.48619Z",
    fill: "#BCBCBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIconRokkApp);
export default __webpack_public_path__ + "static/media/apple_icon_rokk_app.392aa8212744c87884b005d2f0545059.svg";
export { ForwardRef as ReactComponent };